module.exports = __webpack_public_path__ + "static/media/FattyPay.1af8b67b.svg";